/* OPENLIQUID Stage 0 — Scroll-Reveal via Inline-Style (!important). Ausfallsicher. */
(function(){
  try{
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(reduce) return;
    function show(el){ el.style.setProperty('opacity','1','important'); el.style.setProperty('transform','none','important'); }
    function hide(el){ el.style.setProperty('opacity','0','important'); el.style.setProperty('transform','translateY(16px)','important'); el.style.setProperty('transition','opacity .6s ease, transform .6s ease','important'); el.dataset.olHidden='1'; }
    function run(){
      var targets=[];
      document.querySelectorAll('[id^="shopify-section"]').forEach(function(sec){
        var id=sec.id||''; if(/header|footer|announc|popup|mini-cart/i.test(id)) return;
        if(sec.getClientRects().length) targets.push(sec);
      });
      if(!targets.length) return;
      // Reveal auf Horizon deaktiviert: Theme überschreibt Section-Opacity (eigenes
      // Animations-System). Bewegung läuft über Horizons native Section-Animationen.
      return;
      var vh=window.innerHeight||800;
      targets.forEach(function(el){ if(el.getBoundingClientRect().top > vh*0.85) hide(el); });
      var hidden=targets.filter(function(el){ return el.dataset.olHidden; });
      if(hidden.length && 'IntersectionObserver' in window){
        var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ show(e.target); io.unobserve(e.target); } }); },{rootMargin:'0px 0px -8% 0px',threshold:0.05});
        hidden.forEach(function(el){ io.observe(el); });
      } else { hidden.forEach(show); }
      // Eine Ausfallsicherung: falls IO katastrophal versagt, nach 4s alles einblenden
      setTimeout(function(){ hidden.forEach(show); },4000);
    }
    function boot(){ setTimeout(run,250); }
    if(document.readyState==='complete') boot(); else window.addEventListener('load',boot);
  }catch(e){}
})();
